<template>
	<div>
		<v-menu bottom left>
			<template v-slot:activator="{ on }">
				<v-btn
					icon
					v-on="on"
					color="primary"
				>
					<v-icon small>far fa-clock</v-icon>
				</v-btn>
			</template>

			<v-list>
				<v-list-item
					v-for="(item, i) in options"
					:key="i"
					@click="changeZone(item)"
				>
					<v-list-item-title>{{ item }}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>

		{{displayTime}}
	</div>
</template>

<script>
import { DateTime } from "luxon";
import { commitTypes } from "../store-types";

export default {
	data() {
		return {
			timer: null,
			displayTime: null,
			options: [],
			zone: "utc",
		};
	},
	created() {
		this.options = [...new Set([
			DateTime.local().zoneName,
			DateTime.utc().zoneName,
			"America/Los_Angeles",
			"Asia/Kolkata",
		])];
		this.zone = this.timeZone;

		this.timer = setInterval(this.refresh, 1000);
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
	methods: {
		refresh() {
			const dtNow = DateTime.local().setZone(this.zone);

			this.displayTime = dtNow.toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET)
				.replace("GMT+5:30", "IST");
		},
		changeZone(newZone) {
			this.zone = newZone;
			this.$store.commit(commitTypes.SET_ZONE, newZone);
			this.$emit("change", newZone);
			this.refresh();
		},
	},
};
</script>
